import '@babel/runtime/helpers/esm/toConsumableArray';
import '@babel/runtime/helpers/esm/defineProperty';
import { padStart } from 'lodash';

var getVisibleTimeByFormat = function getVisibleTimeByFormat(format) {
  return {
    showHours: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
    showMinutes: format.indexOf('m') > -1,
    showSeconds: format.indexOf('s') > -1,
    use12Hours: format.indexOf('A') > -1 || format.indexOf('h') > -1 || format.indexOf('a') > -1
  };
};
var addLeadingZeros = function addLeadingZeros(count) {
  return function (number) {
    return padStart(String(number), count, '0');
  };
};

export { addLeadingZeros, getVisibleTimeByFormat };
//# sourceMappingURL=timeUtils.js.map
